(() => {
  const mobile = matchMedia('(max-width: 749.98px)');
  let scheduled = false;
  let controls = [];
  const refresh = () => {
    controls = [...document.querySelectorAll('main a[href], main button, main input, main select, main textarea, main h1, main h2, main h3, main .custom-tab, main form, .footer-block summary')];
  };
  const intersects = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  const update = () => {
    scheduled = false;
    const chat = document.querySelector('shopify-chat');
    const activator = chat?.shadowRoot?.querySelector('[part="activator"]');
    const top = document.querySelector('.scroll-to-top-button');
    const targets = [[chat, activator, 'zenhax-chat-clear'], [top, top, 'zenhax-control-clear']];
    const openOverlay = !!document.querySelector('body.overflow-hidden, body.overflow-hidden-mobile, dialog[open], .menu-drawer-container[open]');
    const areas = mobile.matches ? controls.filter(e => e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden').map(e => e.getBoundingClientRect()).filter(r => r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth) : [];
    for (const [host, button, name] of targets) {
      if (!host || !button) continue;
      const focused = button.matches(':focus, :focus-within');
      const opened = button.getAttribute('aria-expanded') === 'true';
      host.classList.toggle(name, mobile.matches && !focused && !opened && (openOverlay || areas.some(r => intersects(button.getBoundingClientRect(), r))));
    }
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  };
  const init = () => {
    refresh();
    addEventListener('scroll', schedule, {passive: true});
    addEventListener('resize', schedule, {passive: true});
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('change', schedule);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('shopify:section:load', () => {refresh(); schedule();});
    mobile.addEventListener('change', schedule);
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    const observer = new MutationObserver(() => {refresh(); schedule();});
    observer.observe(document.querySelector('main'), {childList: true, subtree: true});
    new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class'], childList: true});
    customElements.whenDefined('shopify-chat').then(() => {
      const chat = document.querySelector('shopify-chat');
      if (chat?.shadowRoot) new MutationObserver(schedule).observe(chat.shadowRoot, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded']});
      schedule();
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
